import webApisClient from '../web-apis-client';
import { cacheKeys, localCache } from '../app-cache';
import { Logger } from '@aws-amplify/core';

const log = new Logger('remote-config-manager');

const minutesInFuture = (minutes: number) =>
  Date.now() + minutes * 60 * 1000;

/**
 * Get details of current user
 * @returns user object
 */
const getUser = () => {
  log.debug('getUser...');

  console.log('User ' + JSON.stringify(localCache.getItem(cacheKeys.user)));
  return localCache.getItem(cacheKeys.user);
};

/**
 * Gets survey content that has been configured in Kentico
 * @returns {SurveyContent}
 */
const getSurveyContent = async () => {
  log.debug('getSurveyContent...');

  let surveyContent = localCache.getItem(cacheKeys.survery_content);

  if (!surveyContent) {
    surveyContent = await webApisClient.getSurveyContent();
    localCache.setItem(cacheKeys.survery_content, surveyContent, {
      expires: minutesInFuture(120),
    });
  }

  return surveyContent;
};

/**
 * Gets a list of customers case and leave ids
 * @returns list of customers case and leave ids
 */
const getCaseIds = async (customerId: any) => {
  log.debug('getCaseIds...');

  const caseIds = await webApisClient.getCaseIds(customerId);

  return caseIds;
};

/**
 * Store survey Results
 */
const storeSurvey = async (survey: any) => {
  log.debug('storeSurvey...');

  const result = await webApisClient.storeSurvey(survey);

  return result;
};

const hasTasks = async (customerno: any) => {
  log.debug('hasTasks...');

  const hasTasks = await webApisClient.hasTasks(customerno);

  return hasTasks;
};

/*******************************************************************************
 * exported api definition
 ******************************************************************************/
const remoteConfigManager = {
  getSurveyContent,
  getCaseIds,
  getUser,
  storeSurvey,
  hasTasks,
};

export default remoteConfigManager;